import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Pessoal do Transporte',
    path: '/transporte/trapessoal',
    name: 'trapessoal',
    component: () => import('@/views/transporte/trapessoal/Index.vue'),
    meta: { permissions: [eTipoPermissao.SERVIDORESTRANSPORTENOVO_MENU_1100400399] },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Pessoal do Transporte',
    parent: 'trapessoal',
    path: '/transporte/trapessoal/cadastro/:id?',
    name: 'trapessoal-create',
    component: () => import('@/views/transporte/trapessoal/Cadastro.vue'),
    meta: { permissions: [eTipoPermissao.SERVIDORESTRANSPORTENOVO_MENU_1100400399] },
    goesToMenu: false,
  },
];
